import { Conversation } from 'ha/services/apiV2/types/Conversation';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface Query {
  expand: string;
}

export default (makeCall: MakeCall) =>
  (conversationId: number, query?: Query) =>
    makeCall<Conversation>(
      'GET',
      `${APIV2_URL}/conversation/${conversationId}`,
      {
        query,
      },
    );
